import React, { useState } from "react";
import * as s from "./index.module.scss";
import secondaryFont from "@/utils/secondaryFont";
import { PrismicRichText } from "@prismicio/react";
import { IoArrowForward } from "react-icons/io5";
import Link from "next/link";
import Popups from "@/components/Common/Popups";

const CtaWithVideo = ({ data, page = "" }) => {
  const videoUrl = data?.videoLink?.url;

  // Convert youtu.be to embed format
  const getEmbedUrl = (url) => {
    if (!url) return null;

    const regExp = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/;
    const match = url.match(regExp);

    return match ? `https://www.youtube.com/embed/${match[1]}` : null;
  };

  const embedUrl = getEmbedUrl(videoUrl);

  const [showModal, setShowModal] = useState(false);

  return (
    <section className={s.cta_with_video}>
      <div className={s.cta_with_video_wrapper}>
        <div className={s.cta_with_video_inner_wrapper}>
          {/* ✅ Video iframe */}
          {embedUrl && (
            <div className={s.video_wrapper}>
              <iframe
                width="100%"
                height="400"
                src={embedUrl}
                title="YouTube video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          )}

          <div className={s.content_wrapper}>
            <div>
              <div className={s.title}>
                <PrismicRichText field={data?.title || []} />
              </div>
              <div className={`${secondaryFont} ${s.description} parapraph`}>
                <PrismicRichText field={data?.description || []} />
              </div>
            </div>

            {/* <div className={s.button_container}>
              <button
                className={`btn btn-mob-pad btn-primary mb-md-0 me-3 ${secondaryFont}`}
                onClick={() => {
                  setShowModal(true);
                }}
              >
                Get a loan offer now{" "}
                <IoArrowForward size="18px" style={{ marginLeft: "8px" }} />
              </button>
              <Link
                href="/collateral-loans"
                className={`btn btn-mob-pad btn-outline-dark ${secondaryFont}`}
              >
                View More{" "}
                <IoArrowForward size="18px" style={{ marginLeft: "8px" }} />
              </Link>
            </div> */}
          </div>
        </div>
      </div>
      {/* <Popups
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        offer={true}
        page={page}
      /> */}
    </section>
  );
};

export default CtaWithVideo;
